import { mutatorAction } from 'satcheljs';
import { getItem } from 'owa-local-storage';
import getMyOutlookViewState from '../store/myOutlookViewState';
import type { MyOutlookTab, MyOutlookEntryState } from '../store/myOutlookViewState';

export function isMyOutlookFullPageShowing(): boolean {
    return getMyOutlookViewState().isFullPageShowing;
}

export function getReadingPaneInitialTab(): MyOutlookTab {
    return getMyOutlookViewState().initialTab;
}

const SECTION_HIDDEN_KEY = 'owa-personal-os-section-hidden';
let sectionHiddenHydrated = false;

const hydrateSectionHiddenMutator: () => void = mutatorAction(
    'hydrateSectionHiddenMutator',
    (): void => {
        try {
            if (getItem(self, SECTION_HIDDEN_KEY) === 'true') {
                getMyOutlookViewState().isSectionHidden = true;
            }
        } catch {
            // localStorage unavailable
        }
    }
);

export function isMyOutlookSectionHidden(): boolean {
    if (!sectionHiddenHydrated) {
        sectionHiddenHydrated = true;
        hydrateSectionHiddenMutator();
    }
    return getMyOutlookViewState().isSectionHidden;
}

export function getEmulatedFolderEntryState(): MyOutlookEntryState | null {
    return getMyOutlookViewState().emulatedEntryState;
}

export function getIsScheduleVisible(): boolean {
    return getMyOutlookViewState().isScheduleVisible;
}

export function getHighlightedActionableItemIds(): string[] {
    return getMyOutlookViewState().highlightedActionableItemIds;
}
